<template>
    <div class="resources">
        <vue-fuse
            :keys="keys"
            :list="pdfs"
            :defaultAll="true"
            @fuseResultsUpdated="onFuseResultsUpdated"
            placeholder="Search for Resources"
            class="search-bar"
            :tokenize="true"
            :threshold="0.3"
        ></vue-fuse>
        <div
            v-for="(entry, i) in results"
            :key="i"
            class="form-card resource"
        >
            <div :class="'resource-icon fa fa-3x ' + entry.icon"></div>
            <div class="resource-description">
                <label class="header-label">{{entry.name}}</label>
                <p>{{entry.description}}</p>
            </div>
            <a :href="entry.link" target="_blank">
                <div class="fa fa-2x fa-download"></div>
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: "resources",
    data () {
        return {
            results: []
        };
    },
    computed: {
        pdfs: () => [
            {
                name: "Lawn & Garden Guide",
                link: "/pdf/Resources/Lawn & Garden Guide.pdf",
                icon: "fa-leaf",
                description: "Recommended Test Packages. Lawn Test. This test gives a foundation of information that can be useful in dictating which nutrients are available."
            },
            {
                name: "Agriculture Soils Season Guide",
                link: "/pdf/Resources/MWL_Agriculture_SoilsSeasonGuide.pdf",
                icon: "fa-pagelines",
                description: "Recommended Test Packages. S1A. Organic Matter, Available Phosphorus. (P1 Weak Bray and P2 Strong Bray) Exchangeable Potassium, Magnesium, Calcium"
            },
            {
                name: "MyLab Portal Quickstart Guide",
                link: "/pdf/Resources/MWL_myLabPortal_QuickstartGuide.pdf",
                icon: "fa-file-pdf-o",
                description: "Hi everyone! My name is Megan Fonfara and I'm the Client Onboarding Specialist at Midwest Labs. My role at the lab is to help our partners get started and submit their samples. I offer training on the MyLab Portal, help answer questions about shipping, supplies, and analysis packages.  Ultimately, I work to create a seamless onboarding experience for all of our partners. One of the most frequent questions I get asked is how do I get started” so I've made a quick guide of how to create an account with Midwest Labs. Check out the step by step process and some hidden features to the MyLab Portal."
            },
            {
                name: "MyLab FAQ",
                link: "/pdf/Resources/MyLab FAQ.pdf",
                icon: "fa-file-pdf-o",
                description: "I cannot click review order. What needs to be fixed? Exverything with an * is required. Make sure you have a description, sample id, and test selected."
            },
            {
                name: "Sampling Size Guide",
                link: "/pdf/Resources/MWL_SampleSizeGuide.pdf",
                icon: "fa-eyedropper",
                description: "This is a list of popular Testing Packages and the required amount of sample material needed to complete the analysis.  This is not a complete list of testing that we offer, so please reach out to your Account Manager for more info on further testing, individual analytes, or other sample sizes not included on this document."
            },
            {
                name: "Territory Map of Field Reps",
                link: "https://midwestlabs.com/common/getfile.aspx/583573",
                icon: "fa-map-marker",
                description: "Northern Region, Canada & International Accounts Jim Fasching Agronomist & Field Representative (Agriculture) (507) 273-3339 JFasching@midwestlabs.com"
            },
            {
                name: "Table of Ratings",
                link: "/pdf/Resources/Table of Ratings.pdf",
                icon: "fa-file-pdf-o",
                description: "Potassium. Magnesium. Calcium. Sodium. P1. P2. Bicarb P. Mehlich 3 P Color. Mehlick 3 P ICP. O.M. Sulfur. Zine. Manganese. Iron. Copper. Boron."
            },
            {
                name : 'Soil Sampling',
                link: '/pdf/SamplingInstructions/soil_sampling.pdf',
                icon: 'fa-flask',
                description : 'Soil Sampling Methods Properly collecting soil samples is the most important step in any nutrient/soil amendment management program. Soil sampling should reflect tillage, past fertilizer/soil amendment placement, cropping patterns (and corresponding irrigation requirements), soil type (including drainage and slope characteristics) and perhaps old field boundaries (such as old feedlots, windrows, altered stream beds, etc.). Trends toward reduced and/or zero tillage and technology for variable rate fertilization (VRF) have especially demanded that soil samples be taken more comprehensively and intensively for more accurate fertilizer and soil amendment application. This brochure will discuss the many methods used for taking an accurate soil sample using various methods and under several different types of tillage situations.'
            },
            {
                name : 'Plant Tissue',
                link: '/pdf/SamplingInstructions/Sampling-Guide-For-Plant-Tissue-Analysis-0910.pdf',
                icon: 'fa-leaf',
                description : 'Plant Tissue Analysis The Increasing Need Modern agriculture demands top yields and quality yields.  Additionally, you demand profitable yields. In satisfying these demands, plant tissue analysis has become a valuable crop production tool.  Top quality and profitable yields, unfortunately, don\'t just happen. Many factors need to be considered ... like adequate moisture and fertility, proper plant population, adapted variety, disease and insect resistance and control ... the list goes on.'
            },
            {
                name : 'Corn Stalks',
                link: '/pdf/SamplingInstructions/NitrateNitrogenLevelsInCornStalks-1.pdf',
                icon: 'fa-pagelines',
                description : 'End of Season Evaluations of Nitrogen Management in Corn The end-of-season cornstalk test is a tool for evaluating nitrogen (N) management practices used in any corn field in any year.  The test is most valuable when used on fields that show no visual signs of N deficiency.  The test is based on the fact that corn plants suffering from inadequate N remove nitrate from the lower cornstalks during the grainfilling period, while corn plants that have extra N accumulate nitrate in their lower stalks during this period. Stalk nitrate-N concentrations can be divided into three categories: low, optimal, and excess.'
            },
            {
                name : 'Swabs',
                link: '/pdf/SamplingInstructions/Swabs Usage Directions.ppt',
                icon: 'fa-flask',
                description : 'Basic Technique for Using Stick Swabs Provided by Midwest Laboratories'
            },
            {
                name : 'Sponges',
                link: '/pdf/SamplingInstructions/Sponge Usage Directions.ppt',
                icon: 'fa-flask',
                description : 'Basic Technique for Using Hydrosponges Provided by Midwest Laboratories'
            },
            {
                name : 'Air Plates',
                link: '/pdf/SamplingInstructions/How to Use Air Plates PDF.pdf',
                icon: 'fa-eyedropper',
                description : 'TO SAMPLE AIR QUALITY: Expose air plates for one hour, one meter (3 ft) above the floor, one meter (3 ft) from any obstacle. Try to limit air flow in area by not opening doors to outside environments.'
            },
            {
                name : 'Domestic Water Sampling',
                link: '/pdf/SamplingInstructions/Domestic water sampling instructions.pdf',
                icon: 'fa-eyedropper',
                description : 'Instructions for Water Sampling. If the objective is to test for the presence of coliforms in the well itself, additional measures should be taken.'
            },
            {
                name : 'Sample Instructions/Safety',
                link: '/pdf/SamplingInstructions/Sample instructions and safety info.pdf',
                icon: 'fa-flask',
                description : 'Sampling Instructions and Safety Information. Water or Wastewater Sample Collection Instructions.'
            },
            {
                name: 'ACH Bank Info Routing',
                link: '/pdf/Resources/MWL_ACH-Bank-Info_Routing.pdf',
                icon: 'fa-money',
                description: 'Midwest Labs is now accepting ACH payments through our new banking partner Pinnacle Bank. We ask that you update using the information below to start taking advantage of this convenient process.'
            },
            {
                name: 'FAQ Pay Invoice',
                link: '/pdf/Resources/MWL_MyLabFAQs_PayInvoice.pdf',
                icon: 'fa-money',
                description: 'Open mylab.midwestlabs.com and click on the button on your left-hand column. ' +
                    'You can click the button to view invoice details or the button to make a payment. ' +
                    'Click on the appropriate credit card or pay with a new card then click'
            }
        ],
        keys: () => [
            "name",
            "description"
        ],
    },
    methods: {
        onFuseResultsUpdated(results) {
            this.results = results;
        }
    }
}
</script>

<style scoped lang="scss">

@import '../../sass/_global_variables.scss';

.resources {
    margin: 1em;

    .resource {
        display: flex;
        flex-direction: row;
        margin-top: 1em;
        padding: 1em;

        .resource-icon {
            width: 1em;
        }

        .resource-description {
            flex: 1;    /* Grow to fill */
        }

        * {
            margin: auto 1em auto 1em;
        }
    }

    .search-bar {
        font-size: 2em;
        width: 100%;
    }
}
</style>



// WEBPACK FOOTER //
// resources.vue?624eadd8